import React, { useState } from "react";
import "./datatable.scss";
import { Input, message } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useNavigate } from "react-router-dom";
import { authSVC } from "../../../services";
import { UndoOutlined } from "@ant-design/icons";
import { AppTable } from "../../common";

interface Contentdata {
  payment: any;
  key?: string;
  _id: string;
  bodyText: string;
  user_id: string;
  video_id: string;
  email: string;
  full_name: string;
  company: string;
  package_name: string;
  company_id: any;
}
// interface DataTableProps {
//     setshowModel: (value: boolean) => void,
//     setEditable: (value: boolean) => void,
//     deleteThought: (value: any) => void,
//     editContent:(value:any)=>void
//     isOpen: boolean,
//     contentData?: Contentdata[]
// }
function ArchiveList({ contentData }: any) {
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  const UnarchiveCompany = (c_id: any) => {
    authSVC
      .UnArchiveCompany({
        company_id: c_id,
      })
      .then((res: any) => {
        message.success(res.data.message);
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((err: any) => {
        message.error(err.response?.data?.error);
      });
  };

  const columns: ColumnsType<Contentdata> = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      width: 100,
      filteredValue: [searchText],
      render: (text) => <div className="truncate">{text}</div>,
      sorter: (a: any, b: any) => a._id.localeCompare(b._id),
      onFilter: (value, record) => {
        return (
          String(record.email).toLowerCase().includes(value.toLocaleString()) ||
          String(record.full_name)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record._id).toLowerCase().includes(value.toLocaleString())
        );
      },
    },
    {
      title: "Business Name",
      width: 150,
      dataIndex: "company",
      key: "company",
    },
    {
      sorter: (a: any, b: any) => a.full_name.localeCompare(b.full_name),
      title: "Name",
      width: 150,
      dataIndex: "full_name",
      key: "full_name",
    },
    {
      title: "Company Email",
      dataIndex: "email",
      width: 250,
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone_number",
      width: 150,
      key: "phone_number",
      render: (text) => <div className="truncate">{text && `+${text}`}</div>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <button
          className="tbl-action-btn tbl-action-btn--approve"
          onClick={() =>
            UnarchiveCompany(record?.payment[0]?.company_id?._id)
          }
        >
          <UndoOutlined />
          Unarchive
        </button>
      ),
    },
  ];

  return (
    <div className="dataTable">
      <div className="filterMenu">
        <div></div>
        <Input.Search
          onSearch={(value) => {
            setSearchText(value);
          }}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          className="searchField"
          placeholder="Search here..."
        />
      </div>
      <AppTable
        className="dataGrid"
        columns={columns}
        dataSource={contentData}
      />
    </div>
  );
}

export default ArchiveList;
